import {type DataLoader, useLoader} from "./DataLoader";
import {computed, type ComputedRef} from "vue";
import type {AgendaPart} from "@t/fd/layout/Agenda";
import {ItemsGrid} from "@t/fd/layout/Items.ts";

export function useDirectDataLoader(all: ComputedRef<any[]>, grid:ItemsGrid):DataLoader {
    const loader = useLoader(grid);

    const data = computed<any[]>(() => {
        if (loader.page.value > 0) {
            const slice:any[] = [];
            for (let i = Math.max(0, loader.position.value); i < Math.min(all.value.length, loader.position.value + loader.page.value); i++) {
                slice.push(all.value[i]);
            }
            return slice;
        } else {
            return all.value;
        }
    });

    const total = computed(() => all.value.length);

    return {
        ...loader,
        data,
        total
    }
}
